import { useState } from "react";
import { addDocumentUserURL } from "../../../utils/ConstantsURL";
import { toastAlert } from "../../../utils/AlertContext";

export const useNewDocument = (token) => {
  const [loading, setLoading] = useState(false);

  const addDocument = async (documents, userId) => {
    const dataItems = {
      documents: documents,
    };

    try {
      setLoading(true);
      const response = await fetch(addDocumentUserURL(userId), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(dataItems),
      });

      if (!response.ok) {
        throw new Error("Error al agregar el documento");
      }

      const data = await response.json();
      toastAlert("Documento agregado correctamente", "success", 3000);
      return data;
    } catch (error) {
      toastAlert("Error al agregar el documento", "error", 3000);
    } finally {
      setLoading(false);
    }
  };

  return { addDocument, loading };
};
